import React from 'react';
import { Link } from 'react-router-dom';
import { type Author, authorInitials } from '../../content/authors';

/** A monochrome initials avatar chip. */
export const AuthorAvatar: React.FC<{ name: string; size?: number }> = ({ name, size = 40 }) => (
  <span
    className="inline-flex items-center justify-center rounded-full bg-secondary-900 text-white dark:bg-white dark:text-secondary-900 font-semibold shrink-0"
    style={{ width: size, height: size, fontSize: size * 0.4 }}
    aria-hidden
  >
    {authorInitials(name)}
  </span>
);

/** Medium-style byline: avatar + author name (links to their page) + tagline / reading time. */
export const AuthorByline: React.FC<{ author: Author; readingTimeMin?: number; updated?: string }> = ({ author, readingTimeMin, updated }) => (
  <div className="flex items-center gap-3">
    <Link to={`/authors/${author.slug}`} aria-label={`About ${author.name}`}><AuthorAvatar name={author.name} /></Link>
    <div className="min-w-0 text-sm">
      <Link to={`/authors/${author.slug}`} className="font-medium text-secondary-900 dark:text-white hover:underline">{author.name}</Link>
      <div className="text-secondary-400">
        {author.tagline}
        {readingTimeMin ? <> · {readingTimeMin} min read</> : null}
        {updated ? <> · {new Date(updated).toLocaleDateString(undefined, { month: 'short', year: 'numeric' })}</> : null}
      </div>
    </div>
  </div>
);

export default AuthorByline;
